module.exports = __webpack_public_path__ + "static/media/17-konkurranse.a5cc9e58.mp3";